import type { ComponentProps } from "react";
import { Card } from "@ptsd/uikit";
import { Image, Text } from "tamagui";

type CardProps = ComponentProps<typeof Card>;

interface EmptyStateProps {
  cardProps?: CardProps;
  imageProps?: ComponentProps<typeof Image> & {
    path?: string;
  };
  text: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  cardProps,
  ...rest
}) => {
  return (
    <Card gap={"$3.4"} maxWidth={1200} paddingHorizontal={"$5"} {...cardProps}>
      <Card.Title textAlign="left">Недостатньо данних</Card.Title>
      <EmptyStateBase {...rest} />
    </Card>
  );
};

export const EmptyStateBase: React.FC<EmptyStateProps> = ({
  cardProps,
  imageProps,
  text,
}) => {
  const {
    path = "/recommendations/nahaduvannia_shcho_dozvoliaiut_ne_vyhority.png",
    source,
    ...rest
  } = imageProps ?? {};

  return (
    <Card
      minHeight={360}
      justifyContent={"center"}
      alignItems={"center"}
      variant="borderless"
      gap={"$1.2"}
      backgroundColor={"$warm-snow-500"}
      {...cardProps}
    >
      <Image
        width={120}
        height={120}
        source={path ? { width: 120, height: 120, uri: path } : source}
        {...rest}
      />
      <Text
        fontFamily={"$subtitle"}
        fontWeight={"$6"}
        fontSize={"$6"}
        lineHeight={"$6"}
        textAlign="center"
        color={"$error-500"}
        maxWidth={700}
      >
        {text}
      </Text>
    </Card>
  );
};
